module.exports = {"Description":"NL : NNNN LL","RedundantCharacters":" -","ValidationRegex":"^[1-9][0-9]{3}(?!SA|SD|SS)[A-Z]{2}$","TestData":{"Valid":["1235DF","5983DH","1000 AP"],"Invalid":["1235D","12j4h","k3j51l","1945SS"]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/postal-codes-js/formats/NL.json
// module id = 4477
// module chunks = 11